import { render, staticRenderFns } from "./MessagePush.vue?vue&type=template&id=f0db3686&scoped=true"
import script from "./MessagePush.vue?vue&type=script&lang=js"
export * from "./MessagePush.vue?vue&type=script&lang=js"
import style0 from "./MessagePush.vue?vue&type=style&index=0&id=f0db3686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0db3686",
  null
  
)

export default component.exports